import angular from 'angular';
import { WhatsAppConnect } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-sportclub-wpp-integration';

angular.module(moduleName, []).directive('sportclubWppIntegration', [
    'Backoffice',
    (Backoffice) => ({
        restrict: 'A',
        link: (_scope, el) => {
            Backoffice.renderComponent(el[0], WhatsAppConnect, {});

            // Cuando se destruye el scope, desmontás el componente
            _scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]); // <- Esto debe llamar a ReactDOM.unmountComponentAtNode
            });
        },
    }),
]);

export default moduleName;
